export const GET_CLIENT_SETTING_REQUEST = 'session/GET_CLIENT_SETTING_REQUEST'
export const GET_CLIENT_SETTING_REQUEST_SUCCESS = 'session/GET_CLIENT_SETTING_REQUEST_SUCCESS'
export const GET_CLIENT_SETTING_REQUEST_FAILURE = 'session/GET_CLIENT_SETTING_REQUEST_FAILURE'
export const GET_CLIENT_SETTING_REQUEST_COMPLETED = 'session/GET_CLIENT_SETTING_REQUEST_COMPLETED'

export const SAVE_CLIENT_SETTING_REQUEST = 'session/SAVE_CLIENT_SETTING_REQUEST'
export const SAVE_CLIENT_SETTING_REQUEST_SUCCESS = 'session/SAVE_CLIENT_SETTING_REQUEST_SUCCESS'
export const SAVE_CLIENT_SETTING_REQUEST_FAILURE = 'session/SAVE_CLIENT_SETTING_REQUEST_FAILURE'
export const SAVE_CLIENT_SETTING_REQUEST_COMPLETED = 'session/SAVE_CLIENT_SETTING_REQUEST_COMPLETED'

export const UPDATE_CLIENT_SETTING_REQUEST = 'session/UPDATE_CLIENT_SETTING_REQUEST'
export const UPDATE_CLIENT_SETTING_REQUEST_SUCCESS = 'session/UPDATE_CLIENT_SETTING_REQUEST_SUCCESS'
export const UPDATE_CLIENT_SETTING_REQUEST_FAILURE = 'session/UPDATE_CLIENT_SETTING_REQUEST_FAILURE'
export const UPDATE_CLIENT_SETTING_REQUEST_COMPLETED = 'session/UPDATE_CLIENT_SETTING_REQUEST_COMPLETED'
